<template>
    <el-container>
        <el-main class="wrapper__body" style="margin-left: 0px;">
            <!-- <Navbar :is_production="is_production" title="Site" style="width: 100%"></Navbar> -->
            <el-container class="main-section">
                <div class="col-md-12">
                    <h1>Student Life</h1> <!--CAN BE ANOTHER TER FOR OTHER SCHOOLS-->
                    <hr>
                    <div class="container">
                        <h2>Categories</h2>
                        <!--ADD FEATURED IMAGE BUTTON-->
                        <el-button @click="dialogVisible = true" icon="el-icon-plus" type="primary" size="mini"> Add Category</el-button>
                        <br>
                        <hr>
                        <el-table
                            :data="resources.categories"
                            style="width: 100%"
                            size="small"
                            empty-text="No Categories Yet"
                            v-loading="tableLoadingCategory"
                            border>
                            <el-table-column
                                    type="index"
                                    align="center"
                                    width="50">
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    resizable
                                    :min-width="300"
                                    label="CONTENT TITLE">
                                <template slot="header">
                                    <span style="color: black;">NAME</span>
                                </template>
                                <template slot-scope="scope">
                                    {{ scope.row.name }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    :min-width="300"
                                    resizable>
                                <template slot="header">
                                    <span style="color: black;">ACTIONS</span>
                                </template>
                                <template slot-scope="scope">
                                    <el-button type="warning" size="mini" @click="editCategory(scope.row)">Edit</el-button>
                                    <!-- <el-button type="warning" size="mini" @click="statusToggle(scope.row.id, scope.row.active)" :disabled="scope.row.active == 0">Deactivate</el-button> -->
                                    <!-- <el-button type="success" size="mini" @click="statusToggle(scope.row.id, scope.row.active)" :disabled="scope.row.active == 1">Activate</el-button> -->
                                    <el-tooltip content="Delete Category" placement="top"><el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteCategory(scope.row)"></el-button></el-tooltip>
                                </template>
                            </el-table-column>
                        </el-table>
                        <br>
                        <br>
                        <h2>Contents</h2>
                        <!--ADD FEATURED CONTENT BUTTON-->
                        <el-button @click="dialogVisible2 = true" icon="el-icon-plus" type="primary" size="mini"> Add Content</el-button>
                        <br>
                        <hr>
                        <el-table
                            :data="resources.event_galleries"
                            style="width: 100%"
                            size="small"
                            empty-text="No Categories Yet"
                            v-loading="tableLoadingCategory"
                            border>
                            <el-table-column
                                    type="index"
                                    align="center"
                                    width="50">
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    resizable
                                    :min-width="400"
                                    label="CONTENT TITLE">
                                <template slot="header">
                                    <span style="color: black;">TITLE</span>
                                </template>
                                <template slot-scope="scope">
                                    {{ scope.row.title }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    resizable
                                    :min-width="300"
                                    label="CONTENT TITLE">
                                <template slot="header">
                                    <span style="color: black;">CATEGORY</span>
                                </template>
                                <template slot-scope="scope">
                                    {{ scope.row.category_name }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    :min-width="300"
                                    resizable>
                                <template slot="header">
                                    <span style="color: black;">ACTIONS</span>
                                </template>
                                <template slot-scope="scope">
                                    <el-button type="warning" size="mini" @click="editEventGalleryContent(scope.row)">Edit</el-button>
                                    <!-- <el-button type="warning" size="mini" @click="statusToggle(scope.row.id, scope.row.active)" :disabled="scope.row.active == 0">Deactivate</el-button> -->
                                    <!-- <el-button type="success" size="mini" @click="statusToggle(scope.row.id, scope.row.active)" :disabled="scope.row.active == 1">Activate</el-button> -->
                                    <el-tooltip content="Delete Content" placement="top"><el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteContent(scope.row.id)"></el-button></el-tooltip>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <!--DIALOGS-->
                <el-dialog title="Category" :visible.sync="dialogVisible" @close="closeCategory()">
                    <el-form ref="uploadForm" :rules="rules" :model="content" label-width="120px" label-position="top">
                        <el-form-item prop="category_name">
                            <el-input placeholder="Enter Category Name" v-model="category.name"></el-input>
                        </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                            <el-button @click="closeCategory()">Close</el-button>
                            <el-button @click="submitCategory()" icon="el-icon-check" type="primary"> Submit</el-button>
                        </span>
                </el-dialog>


                <el-dialog :title="event_gallery.id !== undefined ? 'Edit Content' : 'Add Content'" :visible.sync="dialogVisible2" @close="closeContentModal()">
                    <div class="container">
                        <el-form ref="uploadForm" :rules="event_gallery.id !== undefined ? rules2 : rules" :model="event_gallery">
                            <el-form-item prop="title" label="Title">
                                <el-input placeholder="Enter Title" v-model="event_gallery.title"></el-input>
                            </el-form-item>
                            <el-form-item prop="category_id" label="Category">
                                <el-select v-model="event_gallery.category_id" placeholder="Select Category" filterable style="width: 275px;">
                                    <el-option
                                            v-for="item in resources.categories"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="content" label="Content">
                                <br>
                                <br>
                                <ckeditor ref="editor" :editor="editor" v-model="event_gallery.content" :config="editorConfig" name="editorData"></ckeditor>
                            </el-form-item>
                            <el-form-item prop="event_date" label="Event Date">
                                <el-date-picker
                                    v-model="event_gallery.event_date"
                                    type="date"
                                    placeholder="Pick a day">
                                </el-date-picker>
                            </el-form-item>
                            <div class="demo-image__preview" v-if="event_gallery.id !== undefined">
                                <el-table
                                    :data="event_gallery.pictures"
                                    size="small"
                                    style="max-height: 300px; overflow-y: scroll;">
                                    <el-table-column
                                        :min-width="200">
                                        <template slot="header">
                                            <span style="color: black;">IMAGE</span>
                                        </template>
                                        <template slot-scope="scope">
                                            <el-image 
                                                :src="scope.row.thumbnail_path"
                                                :preview-src-list="[scope.row.full_path]">
                                            </el-image>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        :max-width="50">
                                        <template slot="header">
                                            <span style="color: black;">ACTION</span>
                                        </template>
                                        <template slot-scope="scope">
                                            <el-button type="danger" size="mini" @click="deleteContentImage(scope.row.id)"><i class="fa fa-trash"></i></el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <el-form-item label="Photos" prop="files">
                                <el-upload
                                        ref="upload"
                                        action=""
                                        name="file[]"
                                        accept="image/png, image/gif, image/jpeg"
                                        :on-remove="handleRemove"
                                        :on-change="handleChange"
                                        :file-list="event_gallery.fileList"
                                        multiple
                                        :auto-upload="false">
                                    <el-button size="small" type="primary">Click to upload</el-button>
                                </el-upload>
                            </el-form-item>
                        </el-form>
                    </div>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="closeContentModal()">Close</el-button>
                        <el-button @click="submitEventGalleryContent()" icon="el-icon-check" type="primary"> Submit</el-button>
                    </span>
                </el-dialog>
                <!--DIALOGS-->
            </el-container>
        </el-main>
    </el-container>
</template>

<script>
    import { event } from "jquery";
import Navbar from "../../../components/admin/Navbar";
    import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
    export default {
        props:{
            is_production: Boolean,
        },
        components: { Navbar },
        data () {
            var validateUpload = (rule, value, callback) => {
                if (this.event_gallery.fileList.length < 1) {
                    callback(new Error('Please upload a upload photos'));
                }else {
                    callback();
                }
            };
            var validateUpload2 = (rule, value, callback) => {
                if (this.event_gallery.pictures.length == 0 && this.event_gallery.fileList.length < 1) {
                    callback(new Error('Please upload a upload photos'));
                }else {
                    callback();
                }
            };
            return {
                // img: this.$root.folder_name + '/public/assets/img/directory_home.png',
                // contents: [],
                env_wp: this.$root.env_wp.env_wp,
                rules: {
                    files: [
                        { validator: validateUpload, trigger: 'change' },
                    ],
                },
                rules2: {
                    files: [
                        { validator: validateUpload2, trigger: 'change' },
                    ],
                },
                content: {
                    fileList: [],
                    featured_content_title: '',
                    featured_content: '',
                },
                tableLoading: false,
                tableLoadingCategory: false,
                dialogVisible: false,
                dialogVisible2: false,
                resources: {
                    categories: [],
                    event_galleries: [],
                },
                category:{
                    name: ''
                },
                event_gallery: {
                    title: '',
                    category_id: '',
                    content: '',
                    event_date: '',
                    fileList: [],
                },
                editor: ClassicEditor,
                editorConfig: {
                    placeholder: 'Type the content here!',
                    toolbar: {
                        items: [
                            'exportPDF','exportWord', '|',
                            'findAndReplace', 'selectAll', '|',
                            'heading', '|',
                            'bold', 'italic', 'strikethrough', 'underline', 'code', 'subscript', 'superscript', 'removeFormat', '|',
                            'bulletedList', 'numberedList', 'todoList', '|',
                            'outdent', 'indent', '|',
                            'undo', 'redo',
                            '-',
                            'fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor', 'highlight', '|',
                            'alignment', '|',
                            'link', 'insertImage', 'blockQuote', 'insertTable', //'mediaEmbed', 
                            'codeBlock', 'htmlEmbed', '|',
                            'specialCharacters', 'horizontalLine', 'pageBreak', '|',
                            'textPartLanguage', '|',
                            'sourceEditing'
                        ],
                        shouldNotGroupWhenFull: true
                    },
                    list: {
                        properties: {
                            styles: true,
                            startIndex: true,
                            reversed: true
                        }
                    },
                    heading: {
                        options: [
                            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                            { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                            { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                            { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                            { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
                            { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
                            { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
                        ]
                    },
                    fontFamily: {
                        options: [
                            'default',
                            'Arial, Helvetica, sans-serif',
                            'Courier New, Courier, monospace',
                            'Georgia, serif',
                            'Lucida Sans Unicode, Lucida Grande, sans-serif',
                            'Tahoma, Geneva, sans-serif',
                            'Times New Roman, Times, serif',
                            'Trebuchet MS, Helvetica, sans-serif',
                            'Verdana, Geneva, sans-serif'
                        ],
                        supportAllValues: true
                    },
                    alignment: {
                        options: [
                            'left', 'right', 'center', 'justify'
                        ],
                        supportAllValues: true
                    },
                    fontSize: {
                        options: [ 10, 12, 14, 'default', 18, 20, 22 ],
                        supportAllValues: true
                    },
                    htmlSupport: {
                        allow: [
                            {
                                name: /.*/,
                                attributes: true,
                                classes: true,
                                styles: true
                            }
                        ]
                    },
                    htmlEmbed: {
                        showPreviews: true
                    },
                    link: {
                        decorators: {
                            addTargetToExternalLinks: true,
                            defaultProtocol: 'https://',
                            toggleDownloadable: {
                                mode: 'manual',
                                label: 'Downloadable',
                                attributes: {
                                    download: 'file'
                                }
                            }
                        }
                    },
                    mention: {
                        feeds: [
                            {
                                marker: '@',
                                feed: [
                                    '@apple', '@bears', '@brownie', '@cake', '@cake', '@candy', '@canes', '@chocolate', '@cookie', '@cotton', '@cream',
                                    '@cupcake', '@danish', '@donut', '@dragée', '@fruitcake', '@gingerbread', '@gummi', '@ice', '@jelly-o',
                                    '@liquorice', '@macaroon', '@marzipan', '@oat', '@pie', '@plum', '@pudding', '@sesame', '@snaps', '@soufflé',
                                    '@sugar', '@sweet', '@topping', '@wafer'
                                ],
                                minimumCharacters: 1
                            }
                        ]
                    },
                    removePlugins: [
                        // These two are commercial, but you can try them out without registering to a trial.
                        // 'ExportPdf',
                        // 'ExportWord',
                        'CKBox',
                        'CKFinder',
                        'EasyImage',
                        // This sample uses the Base64UploadAdapter to handle image uploads as it requires no configuration.
                        // https://ckeditor.com/docs/ckeditor5/latest/features/images/image-upload/base64-upload-adapter.html
                        // Storing images as Base64 is usually a very bad idea.
                        // Replace it on production website with other solutions:
                        // https://ckeditor.com/docs/ckeditor5/latest/features/images/image-upload/image-upload.html
                        // 'Base64UploadAdapter',
                        'RealTimeCollaborativeComments',
                        'RealTimeCollaborativeTrackChanges',
                        'RealTimeCollaborativeRevisionHistory',
                        'PresenceList',
                        'Comments',
                        'TrackChanges',
                        'TrackChangesData',
                        'RevisionHistory',
                        'Pagination',
                        'WProofreader',
                        // Careful, with the Mathtype plugin CKEditor will not load when loading this sample
                        // from a local file system (file://) - load this site via HTTP server if you enable MathType
                        'MathType'
                    ],
                    // toolbar: ['heading', '|', 'fontSize', 'fontFamily', '|', 'bold', 'italic', 'Underline', 'Strikethrough', 'Highlight', '|', 'alignment', '|', 'numberedList', 'bulletedList', '|', 'link', 'blockQuote', 'insertTable', '|', 'undo', 'redo'],
                    // heading: {
                    //     options: [
                    //         {model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph'},
                    //         {model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1'},
                    //         {model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2'},
                    //         {model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3'},
                    //         {model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4'},
                    //         {model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5'},
                    //         {model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6'},
                    //     ]
                    // },
                    // ckfinder: {
                    //     uploadUrl: 'api/ckfinder/connector',
                    //     connectorPath: 'api/ckfinder/connector',
                    //     filebrowserBrowseUrl: '/ckfinder/browser',
                    //     filebrowserImageBrowseUrl: 'api/ckfinder/browser?type=Images',
                    //     filebrowserUploadUrl: 'api/ckfinder/connector?command=QuickUpload&type=Files',
                    //     filebrowserImageUploadUrl: 'api/ckfinder/connector?command=QuickUpload&type=Images',
                    //     options: {
                    //         resourceType: 'Images'
                    //     }
                    // }
                },
                custom_modal_title: '',
                customModalVisible: false,
            }
        },
        async mounted() {
            this.getAllContents();
        },
        methods: {
            async getAllContents(){
                await this.getCategories();
                await this.getEventGallery();
            },
            toggleWhatsAndEventModal(content, type){
                //CONTENT: 1-whats going on, 2-events
                //TYPE: 'create', 'edit'
                if(content == 1){
                    if(type == 'create'){
                        this.custom_modal_title = "Add What's Going On Content";
                        //insert axios post here
                    }

                    if(type == 'edit'){
                        this.custom_modal_title = "Edit What's Going On Content";
                        //insert axios post here
                    }
                }

                if(content == 2){
                    if(type == 'create'){
                        this.custom_modal_title = "Add Events Content";
                        //insert axios post here
                    }

                    if(type == 'edit'){
                        this.custom_modal_title = "Edit Events Content";
                        //insert axios post here
                    }
                }
            },
            handleRemove(file, fileList) {
                const index = this.event_gallery.fileList.indexOf(file);
                this.event_gallery.fileList.splice(index, 1);
            },
            handleChange(file, fileList) {
                // if(this.content.type == 2){
                //     this.content.fileList.splice(0, 1);
                //     this.content.fileList = fileList;
                // }else{
                //     this.content.fileList = fileList;
                // }
                this.event_gallery.fileList.splice(0, 1);
                this.event_gallery.fileList = fileList;
            },
            submitFeaturedImages(){
                this.$refs['uploadForm'].validate((valid) => {
                    if (valid) {
                        let formData = new FormData();
                        if(this.content.fileList.length > 0){
                            for(var i=0; i < this.content.fileList.length; i++) {
                                formData.append('files[]', this.content.fileList[i].raw);
                            }
                        }
                        axios.post(this.env_wp.FOLDER_NAME + '/news/submit_featured_images', formData)
                            .then(res => {
                                // this.getHeadersList();
                                this.$swal(res.data.title, res.data.text, res.data.type);
                                this.content.fileList = [];
                                this.dialogVisible = false;
                            })
                            .catch(err => {
                                //
                            });
                    }
                });
            },
            submitFeaturedContent(){
                if(this.content.featured_content === ''){
                    this.$swal('Oops', 'Content cannot be empty.', 'error');
                }else{
                    var params = {
                        featured_content: this.resources.featured_content
                    }
                    axios.post(this.env_wp.FOLDER_NAME + '/news/submit_featured_content', params)
                    .then(res => {
                        this.$swal(res.data.title, res.data.text, res.data.type);
                        //INSERT GET FEATURED CONTENT METHOD HERE
                    })
                    .catch(err => {

                    })
                }
            },
            submitCategory(){
                var endpoint = '';
                if(this.category.name === ''){
                    this.$swal('Oops', 'Category name cannot be empty.', 'error');
                }else{
                    endpoint = (this.category.id === undefined) ? 'create_category' : 'update_category';

                    axios.post(this.env_wp.FOLDER_NAME + '/event_gallery/'+ endpoint, this.category)
                    .then(res => {
                        this.$swal(res.data.title, res.data.text, res.data.type);
                        this.dialogVisible = false;
                        this.category = {
                            name: ''
                        };
                        this.getCategories();
                    })
                    .catch(err => {

                    })
                }
            },
            getCategories(){
                this.tableLoadingCategory = true;
                axios.get(this.env_wp.FOLDER_NAME + '/event_gallery/get_categories')
                    .then(res => {
                        this.resources.categories = res.data;
                        this.tableLoadingCategory = false;
                        this.event_gallery.category_id = this.resources.categories[0].id;
                    })
                    .catch(err => {
                        this.resources.categories = [];
                        this.tableLoadingCategory = false;
                        this.event_gallery.category_id = '';
                    });
            },
            editCategory(category){
                this.category = category;
                this.dialogVisible = true;
            },
            closeCategory(){
                this.dialogVisible = false;
                this.category = {
                    name: ''
                };
            },
            deleteCategory(category){
                this.$swal({
                    title: 'Confirm?',
                    text: "Are you sure you want to delete this category?",
                    icon: 'warning',
                    buttons: true,
                    dangerMode: true,
                    showCancelButton: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.post(this.env_wp.FOLDER_NAME + '/event_gallery/delete_category', {id: category.id})
                        .then(res => {
                            this.$swal(res.data.title, res.data.text, res.data.type);
                            this.getCategories();
                        })
                        .catch(err => {
                            //
                        });
                    }
                });
            },
            submitEventGalleryContent(){
                if(this.event_gallery.title === ''){
                    this.$swal('Oops', 'Title cannot be empty.', 'error');
                    return;
                }
                // if(this.event_gallery.content === ''){
                //     this.$swal('Oops', 'Content cannot be empty.', 'error');
                //     return;
                // }
                if(this.event_gallery.event_date === ''){
                    this.$swal('Oops', 'Event date cannot be empty.', 'error');
                    return;
                }
                var endpoint = (this.event_gallery.id === undefined) ? 'submit_event_gallery' : 'update_event_gallery';
                this.$refs['uploadForm'].validate((valid) => {
                    if (valid) {
                        let formData = new FormData();
                        if(this.event_gallery.id !== undefined) formData.append('id', this.event_gallery.id);
                        formData.append('title', this.event_gallery.title);
                        formData.append('content', this.event_gallery.content);
                        formData.append('category_id', this.event_gallery.category_id);
                        const localDate = new Date(this.event_gallery.event_date);
                        const adjustedDate = new Date(localDate.getTime() - localDate.getTimezoneOffset() * 60000).toISOString().split('T')[0];
                        formData.append('event_date', adjustedDate);
                        if(this.event_gallery.fileList.length > 0){
                            for(var i=0; i < this.event_gallery.fileList.length; i++) {
                                formData.append('files[]', this.event_gallery.fileList[i].raw);
                            }
                        }
                        axios.post(this.env_wp.FOLDER_NAME + '/event_gallery/'+ endpoint, formData)
                            .then(res => {
                                this.$swal(res.data.title, res.data.text, res.data.type);
                                this.event_gallery = {
                                    title: '',
                                    content: '',
                                    category_id: this.resources.categories[0].id,
                                    event_date: '',
                                    fileList: [],
                                };
                                this.dialogVisible2 = false;
                                this.getEventGallery();
                            })
                            .catch(err => {
                                //
                            });
                    }
                });
            },
            closeContentModal(){
                this.dialogVisible2 = false;
                this.event_gallery = {
                    title: '',
                    content: '',
                    category_id: this.resources.categories[0].id,
                    event_date: '',
                    fileList: [],
                };
                
            },
            getEventGallery(){
                this.tableLoading = true;
                axios.get(this.env_wp.FOLDER_NAME + '/event_gallery/get_event_gallery')
                .then(res => {
                    this.resources.event_galleries = res.data;
                    this.tableLoading = false;
                })
                .catch(err => {
                    this.resources.event_galleries = [];
                    this.tableLoading = false;
                });
            },
            editEventGalleryContent(content){
                this.event_gallery = content;
                this.event_gallery.fileList = [];
                this.dialogVisible2 = true;
            },
            deleteContentImage(id){
                this.$swal({
                icon: 'warning',
                title: 'Confirm?',
                html: 'Are you sure you want to delete this image?',
                showCancelButton: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.post(this.env_wp.FOLDER_NAME + '/event_gallery/delete_content_image', {id: id})
                        .then(res => {
                            this.$swal(res.data.title, res.data.text, res.data.type);
                            this.getEventGallery();
                            this.closeContentModal();
                        })
                        .catch(err => {
                            //
                        });
                    }
                })
            },
            deleteContent(id){
                this.$swal({
                    icon: 'warning',
                    title: 'Confirm?',
                    html: 'Are you sure you want to delete this content?',
                    showCancelButton: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.post(this.env_wp.FOLDER_NAME + '/event_gallery/delete_content', {id: id})
                        .then(res => {
                            this.$swal(res.data.title, res.data.text, res.data.type);
                            this.getEventGallery();
                        })
                        .catch(err => {
                            //
                        });
                    }
                })
            }
        }
    }
</script>
